export default __webpack_public_path__ + "static/media/minichart.0c91d821.svg";